
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class App extends Vue {
  public dialog = false;
  public drawer = true;
  public token = '';
  public redirect = '';
  public formTitle = 'افزایش اعتبار';
  public notices = [];
  public paymentProviders = [
    { id: 1, name: 'پارسیان' },
    { id: 2, name: 'سامان' }
  ];
  public editedItem = {
    paymentProviderId: 2,
    amount: 0
  };
  public defaultItem = {
    paymentProviderId: 2,
    amount: 0
  };

  public items = [
    { title: 'صفحه اصلی', icon: 'mdi-view-dashboard-outline', link: '/' },
    { title: 'مدیریت شرکت ها', icon: 'mdi-domain', link: '/company/manage' },
    { title: 'مدیریت گروه ها', icon: 'mdi-group', link: '/group/manage' },
    { title: 'مدیریت سیم کارت ها', icon: 'mdi-sim-outline', link: '/sim/manage' },
    { title: 'گزارشات', icon: 'mdi-chart-arc', link: '/report', children: null },
    { title: 'مدیریت کاربران', icon: 'mdi-account-outline', link: '/user/manage', children: null },
    // {
    //   'title': 'مالی',
    //   'icon': 'mdi-chevron-up',
    //   'icon-alt': 'mdi-chevron-down',
    //   'model': false,
    //   'children': [{ title: 'فاکتورهای فروش', icon: 'mdi-receipt-text', link: '/invoice/manage' }]
    // },
    {
      'title': 'تنظیمات',
      'icon': 'mdi-chevron-up',
      'icon-alt': 'mdi-chevron-down',
      'model': false,
      'children': [{ title: 'موضوعات پشتیبانی', icon: 'mdi-face-agent', link: '/portal/support-subject' }]
    }
  ];

  async created() {
    if (this.$store.getters.isLoggedIn) {
      this.initialize();
    }
  }

  async initialize() {
    this.$showLoading();
    await Api.getNotificationShortList().then((response: any) => {
      this.notices = response.data;
    });

    await Api.getWalletBalance().then((response: any) => {
      this.$store.dispatch('balance', response.data);
      this.$hideLoading();
    });
  }

  async close() {
    this.dialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    await this.initialize();
  }

  formatPrice(value: number) {
    const val = (value / 1).toFixed(0).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  async Payment() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.createWalletPayment(this.editedItem.paymentProviderId, this.editedItem.amount).then((response: any) => {
      this.$showNotification('success', 'انتقال به سایت بانک');
      if (response.data.pspId == 1) {
        location.replace(response.data.location);
      } else {
        this.token = response.data.token;
        this.redirect = response.data.location;
        this.$nextTick(() => {
          (this.$refs.submitForm as any).submit();
        });
      }

      this.close();
      this.$hideLoading();
    });
  }

  logout() {
    this.$showLoading();
    this.$store.dispatch('logout').then(() => this.$router.push({ name: 'Login' }));
    this.$hideLoading();
  }
}
